import { BookingMethods } from "shared-types/index";

const NS = 'TypeSelectCtrl';

export default function TypeSelectCtrl(
  $rootScope, bookDate, bookTable
) {
  "ngInject";

  const vm = this;
  let disabled = false;
  vm.phoneBooking = phoneBooking;
  vm.walkInBooking = walkInBooking;

  function phoneBooking() {
    if (!disabled) {
      disabled = true;
      $rootScope.$emit('new-booking', null, bookDate, bookTable, BookingMethods.phone);
    }
  }

  function walkInBooking() {
    if (!disabled) {
      disabled = true;
      $rootScope.$emit('new-booking', null, bookDate, bookTable, BookingMethods.walkin);
    }
  }
}
